import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import SymptomSelector from '../../../Symptom/SymptomSelector';
import { useApiClient } from '../../../../context/ApiClientContext';

function AddDeniedSymptomToNarrativeForm(props) {
  const { actionListId, onSuccess } = props;

  const apiClient = useApiClient();

  return (
    <Grid container>
      <Grid item xs={6}>
        <SymptomSelector
          handleSymptomAdd={
              (symptomId) => apiClient.addDeniedSymptomToNarrative(actionListId, symptomId)
            }
          buttonText="Add"
          successMsg="Success"
          onSuccess={onSuccess}
        />
      </Grid>
    </Grid>
  );
}

AddDeniedSymptomToNarrativeForm.propTypes = {
  actionListId: PropTypes.number.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

export default AddDeniedSymptomToNarrativeForm;
